var Theme = Theme || {};

Theme.Issue = (function ($) {

    return {
        init: _init
    };

    function _init() {
        _toggleNestedJumplinks();
        _filterTopicTerms();
        _updateIssueBrowseOnChange();
    }

    function _toggleNestedJumplinks() {
        var $jumplinkArrow = $('.section-jump-link .list-toggle, .section-jump-link .mobile-list-toggle');

        $jumplinkArrow.on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $nearestSublist = $this.parents('.section-jump-link__link-wrap').siblings('ul.section-jump-link__sublist');
            var $arrowRightClass = 'icon-general-arrow-filled-right';
            var $arrowDownClass = 'icon-general-arrow-filled-down';
            var $mobileArrowRight = 'icon-general_arrow-right';
            var $mobileArrowDown = 'icon-general_arrow-down';

            if ($this.hasClass('list-toggle')) {
                $this.hasClass($arrowRightClass) ? $this.removeClass($arrowRightClass).addClass($arrowDownClass) : $this.removeClass($arrowDownClass).addClass($arrowRightClass);
            }

            if ($this.hasClass('mobile-list-toggle')) {
                $this.hasClass($mobileArrowRight) ? $this.removeClass($mobileArrowRight).addClass($mobileArrowDown) : $this.removeClass($mobileArrowDown).addClass($mobileArrowRight);
            }

            $this.attr('aria-expanded') === 'false' ? $this.attr('aria-expanded', 'true') : $this.attr('aria-expanded', 'false');
            $nearestSublist.slideToggle();
        });
    }

    function _filterTopicTerms() {
        $('.issue-topic__input').on('keyup', function () {
            var term = $(this).val();
            var capitalized = term.charAt(0).toUpperCase() + term.substr(1);
            var allLower = term.toLowerCase();
            var caseArray = [capitalized, allLower];

            $('.issue-topic__term').hide();

            if (!term) {
                $('.issue-topic__term').show();
                return;
            }

            for (var i = 0; i < caseArray.length; i++) {
                $(`.issue-topic__term:contains('${caseArray[i]}')`).show();
            }
        });
    }

    function _updateIssueBrowseOnChange() {
        $('.issue-browse-select').on('change', function () {
            window.location.href = $(this).val();
        });
    }

})(jQuery);

// If we are in a module context, export this module
'object' === typeof module && module.exports && (module.exports = Theme.Issue);
